import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-trigger-ausloesen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichTriggerAusloesenEffects {

    BereichTriggerAusloesen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_TRIGGER_AUSLOESEN),
        mergeMap((x: ac.PostBereichTriggerAusloesenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichTriggerAusloesen(x.bereichTriggerRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichTriggerAusloesenErfolgreichAction(result, x.bereichTriggerRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichTriggerAusloesenFehlerAction(error, x.bereichTriggerRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungCommandService);
        }
        return this.service;
    }
}
